import React, { useEffect, useState } from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { getPosttypeChatlist } from "../../../redux/chatandnotification/action";
import ChatInputBox from "./ChatInputBox";
import { Modal } from "reactstrap";
import OverallRatings from "../OverallRatings";
import ChatScrollBottom from "../ChatwithMultipleUser/ChatScrollBottom";
import { useChatPagination } from "../../../Context/ChatPaginationContext";

export default function MessageandFileDetails({ posts, scroll = 0 }) {
  const path = "Assets/scss/chat.module.scss";
  const { index, size } = useChatPagination();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (Array.isArray(posts?.proposal) && posts?.is_mine == 1) {
      setproposalmilestones(posts.proposal[0]);
    } else if (Array.isArray(posts?.my_proposal) && posts?.is_mine == 0) {
      setproposalmilestones(posts.my_proposal[0]);
    }
  }, [posts]);

  const dispatch = useDispatch();

  const [proposalmilestones, setproposalmilestones] = useState("");
  const chatdatails = useSelector(
    ({ chatandnotification: { getposttypechatlist } }) => getposttypechatlist,
  );
  const notificationCount = useSelector(({ chatandnotification: { getnotificationcount } }) => getnotificationcount);

  useEffect(() => {
    if (posts && proposalmilestones) {
      dispatch(
        getPosttypeChatlist(
          1,
          posts?.id,
          posts?.is_mine == 1 ? proposalmilestones?.user_id : posts?.user_id,
          index,
          size
        ),
      );
    }
  }, [posts, proposalmilestones, notificationCount.notification, size, index]);

  const reversedChatdatails = Array.isArray(chatdatails?.messages)
    ? [...chatdatails?.messages].reverse()
    : [];

  return (
    <div className="chat-message">
      <div className="chatbox-second">
        <ChatScrollBottom chatdatails={chatdatails} scroll={scroll} />
      </div>
      <ChatInputBox posts={posts} proposalmilestones={proposalmilestones} />

      <Modal
        isOpen={modal}
        keyboard={false}
        className="modal-centered popupmodal"
        size="xl"
      >
        <OverallRatings setModal={setModal} modal={modal} />
      </Modal>
    </div>
  );
}
